export const NavbarDropdownItems = [
  {
    title: "cemlife",
    path: "/cem-life#cem-life",
    cName: "dropdown-link",
  },
  {
    title: "cemtest",
    path: "/cem-test#cem-test",
    cName: "dropdown-link",
  },
  {
    title: "true sight",
    path: "/ts400#ts400",
    cName: "dropdown-link",
  },
  {
    // title: "Инженерное сопровождение",
    title: "engineering support",
    path: "/engineering-support#engineering-support",
    cName: "dropdown-link",
  },
  {
    // title: "Цем. головы",
    title: "cementing Heads",
    path: "/cem-heads#cem-heads",
    cName: "dropdown-link",
  },
  {
    // title: "Обучение персонала",
    title: "staff training",
    path: "/staff-training#staff-training",
    cName: "dropdown-link",
  },
  {
    // title: "Расчет реологических свойств",
    title: "rheological properties calculation",
    path: "/rheology-calculator#rheology-calculator",
    cName: "dropdown-link",
  },
];
